/**
 * `#collab` (`template.html` dòng 812–836). Hai phần: cột trái (đầu section + 4 hàng tính năng)
 * và cột phải (mock danh sách topic).
 */

/**
 * Một hàng tính năng ở cột trái.
 *
 * `shortcut` chỉ có ở MỘT hàng trong bốn, nên nó tuỳ chọn và mảng được gán kiểu tường minh —
 * ba hàng còn lại không phải đi qua hình dạng phức tạp chỉ vì hàng thứ tư cần nó.
 *
 * VÌ SAO tách phím tắt ra khỏi `term`: thiết kế viết `Quick switch` cộng ký tự phím Command
 * U+2318 rồi tới `K`. Ký tự U+2318 KHÔNG có glyph trong bất kỳ file font nguồn nào của bundle —
 * đã quét `characterSet` cả 31 file
 * `.woff2` trong `/tmp/nexa-design`. Không phải thiếu `unicode-range` (sinh lại font sẽ vá được)
 * mà thiếu ở chính file nguồn, nên KHÔNG lượt `gen:fonts` nào cứu được. Để nguyên thì nó rơi về
 * font hệ thống ngay giữa một dòng chữ. Quyết định của user 2026-08-19: vẽ bằng icon `command`,
 * giữ đúng thiết kế thay vì đổi chuỗi thành `Cmd+K`.
 *
 * `label` là chuỗi cho screen reader, và nó DỊCH ĐƯỢC nên nằm ở copy chứ không ở component.
 */
interface FeatureCopy {
  readonly icon: 'corner-down-right' | 'clock' | 'mic' | 'command';
  readonly term: string;
  readonly body: string;
  readonly shortcut?: {
    readonly icon: 'command';
    readonly label: string;
    readonly key: string;
  };
}

/**
 * Một topic trong mock cột phải.
 *
 * `badge.kind` là ba HÌNH DẠNG đo được, không phải ba mức độ của một hình: `mention` là pill nền
 * brand chữ trắng, `count` là pill nền xám, `live` là chữ trần màu success. Gộp thành một hình
 * rồi đổi màu là làm sai hai trong ba.
 */
interface TopicCopy {
  readonly icon: 'corner-down-right' | 'mic';
  readonly name: string;
  readonly meta: string;
  readonly badge: {
    readonly kind: 'mention' | 'count' | 'live';
    readonly text: string;
  };
  readonly active?: boolean;
}

const features: readonly FeatureCopy[] = [
  {
    icon: 'corner-down-right',
    term: 'Thread',
    body: 'trả lời mở ở panel bên phải, không mất mạch chính.',
  },
  {
    icon: 'clock',
    term: 'Tin nhắn hẹn giờ',
    body: 'lên lịch, lặp lại, đổi lịch hoặc gửi ngay.',
  },
  {
    icon: 'mic',
    term: 'Phòng thoại',
    body: 'một topic có thể là phòng LIVE; thấy ai đang có mặt trước khi vào.',
  },
  {
    icon: 'command',
    term: 'Quick switch',
    shortcut: { icon: 'command', label: 'phím Command', key: 'K' },
    body: 'nhảy tới bất kỳ channel, người hoặc topic bằng bàn phím.',
  },
];

const topics: readonly TopicCopy[] = [
  {
    icon: 'corner-down-right',
    name: 'go-no-go',
    meta: 'Ben N.: readiness đang ở 86%…',
    badge: { kind: 'mention', text: '@2' },
    active: true,
  },
  {
    icon: 'corner-down-right',
    name: 'rollout-pipeline',
    meta: 'Atlas: deploy stage đã xong',
    badge: { kind: 'count', text: '5' },
  },
  {
    icon: 'mic',
    name: 'war-room',
    meta: '4 người đang trong phòng',
    badge: { kind: 'live', text: 'LIVE' },
  },
];

export const collab = {
  eyebrow: 'Chat & Topic',
  heading: 'Channel vẫn dễ đọc khi mỗi luồng có phòng riêng.',
  lead: 'Topic giữ các cuộc trò chuyện song song trong cùng một channel mà không làm loãng nó — mỗi topic có badge chưa đọc và nhắc tên riêng, để bạn luôn biết mình đang được cần ở đâu.',
  features,
  mock: {
    channel: 'q2-launch',
    topicCount: '3 topics',
    topics,
    scheduled: 'Hẹn giờ — gửi 09:00 ngày mai vào #q2-launch',
  },
};
